import { baseQuery } from "src/store/helpers/baseQuery";

import { createApi } from "@reduxjs/toolkit/query/react";

import rtkClient from "./rtkClient";

export const downloadsApi = createApi({
    reducerPath: "downloadsApi",
    tagTypes: ["Releases"],
    keepUnusedDataFor: 600,
    baseQuery,
    endpoints: (builder) => ({
        getReleases: rtkClient.getReleases(builder),
    }),
});

export const { useGetReleasesQuery } = downloadsApi;
